import { memo, useState, useEffect, useRef, useContext } from "react";
import { Button, Text, Flex, AutoRenewIcon, CopyIcon, } from "@pancakeswap/uikit";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import { CopyOutlined, LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useAppSelector, useAppDispatch } from "@/hooks/useStore";
import { ERC20ABI, NOVIP_AMOUNT, MainTokenConfig } from "@/config";
import { useWeb3React } from "@/hooks";
import { Notification } from "@/components";
import { copyHandler, isBNBHandler, addressHand, errorHandler, isMainAddress } from "@/utils";
import { botConfig, token, feeV3, spenToken, router, privatekeyArray, mainConfig, chainId, rpc, batchConfig, isSlippage, isAdvanced, v3Factory, quoter, universalRouter, vipChange, pool, poolChange, swapTypeChange, slippage, permit2, vip, } from "@/store";
import { TokenType } from "@/store/type";
import { AppContext } from "@/context";
import { getRandomNumber, getTime, getOnGasFee } from "@/utils/bot";
import copy from "@/utils/copy";
import { StartBot, LogoSwapper } from "./style";
import { MUMBERADDRESS, MemberABI } from "@/config";
import { useAccount } from "wagmi";
import { WalletBtn } from "@/views/MarKetBot/MarketBotLeft/Footer/style";
import { getPrice } from "@/utils/getPrice";
import { chains, wagmiConfig } from "@/utils/wagmi";
import { useExecuteSwapWithFee } from "@/hooks/executeSwapWithFee";
import { isApp } from "@/utils/isApp";
import ModelInput from "@/components/ModelInput/index1";
import { ModalInfo } from "@/views/MarKetBot/MarketBotLeft/Footer";
import useIsFilled from "@/hooks/useIsFilled";
import useCalculateSlippageAmount from "@/hooks/useCalculateSlippageAmount";
import useFuncName from "@/hooks/useFuncName";
import { swapHandle } from "@/views/MarKetBot/executeSwap";
import { useProviderInstance } from "@/context/ProviderContext";
import { useWalletInfoContext } from "@/context/WalletInfoContext";
import { formatUnits, isAddress, parseUnits } from "viem";
import { createViemWallet } from "@/utils/createViemWallet";
import { BigNumber } from "bignumber.js";
import { waitForTransactionReceipt } from "@wagmi/core";
import { to0xString } from "@/utils/toHex";
import { FormLabel } from "../../MarketBotLeft/Header/style";

export const Blue = "#24adf3";
export const ERROR = "red";
export const Green = "#42b983";

const DEFAULTTIME = "00:00:00:00";

function App() {
  const { Lang } = useContext(AppContext);
  const GPDX = Lang.q14;
  const { account } = useWeb3React()

  const dispatch = useAppDispatch();
  const provider = useProviderInstance();
  const WETHToken = useRef("");
  const poolKeyArray = useRef([]);
  const { walletAddrArr, getWalletInfo, walletConfig, tokenIsA, spenTokenIsA } = useWalletInfoContext();
  const _token = useSelector(token);
  const _pool = useSelector(pool);
  const _feeV3 = useSelector(feeV3);
  const _spenToken = useSelector(spenToken);
  // const _pairToken = useSelector(pairToken)
  const _botConfig = useSelector(botConfig);
  const _mainConfig = useSelector(mainConfig);
  const _router = useSelector(router);
  const _privatekeyArray = useSelector(privatekeyArray);
  const _chainId = useSelector(chainId);
  const _rpc = useSelector(rpc);
  const _batchConfig = useSelector(batchConfig);
  const _isSlippage = useSelector(isSlippage);
  const _isAdvanced = useSelector(isAdvanced);
  const _quoter = useSelector(quoter);
  const _universalRouter = useSelector(universalRouter);
  const _vip = useSelector(vip)

  const [exchange, setExchange] = useState("");

  const logHandler = (
    content: string,
    color?: string,
    hash?: string,
    num?: number,
  ) => {
    const newTime = new Date().getTime();
    const time = getTime(newTime);
    setLogoArr((item) => [...item, { time, content, color, num, hash }]);
  };
  const { executeSwapWithFee, tokenApproveHandler } = useExecuteSwapWithFee();
  const { calculateSlippageAmount, trageLimitNeedETH } =
    useCalculateSlippageAmount();
  const isFilled = useIsFilled();
  const getFuncName = useFuncName();
  const executeSwapSingle = swapHandle();
  useEffect(() => {
    dispatch(poolChange({ pairAddress: "", price: "", WETHToken: "" }));
  }, [_chainId, _spenToken?.address, _token?.address]);

  useEffect(() => {
    const data = _router.label;
    const type = data.includes("V4")
      ? "V4"
      : data.includes("V3")
        ? "V3"
        : data.includes("V2")
          ? "V2"
          : data;
    dispatch(swapTypeChange(type));
    setExchange(type);
  }, [_router]);

  // 打印日志 数组
  const [logoArr, setLogoArr] = useState([]);

  // 数据记录
  const [index, setIndex] = useState(0); // 执行次数
  const [walletNotGasError, setWalletNotGasError] = useState(0);
  const [isStartBot, setIsStartBot] = useState(false); // 开始执行
  const [stopBot, setStopBot] = useState(false); // 停止执行
  // 数据初始化
  const dataInit = () => {
    setLogoArr([]);
    setIndex(0);
    // setErrorIndex({ index: 0, type: 0 })
    setIsStartBot(true);
    setStopBot(false);
    setWalletNotGasError(0);
  };

  const [isServeError, setIsServeError] = useState(false);
  useEffect(() => {
    if (provider && isServeError && _rpc === provider.connection.url) {
      // console.log(provider.connection.url, 'provider.connection.url')
      setIsServeError(false);
      logHandler(Lang.Nodeupdatedsuccessfully);
      startExecuteBot(index);
    }
  }, [provider, isServeError, _rpc]);

  const downTimeRef = useRef(null); // 机器人定时执行倒计时
  const [downTime, setDownTime] = useState(DEFAULTTIME); // 倒计时时间

  // 开始执行按钮
  const startBtnClick = async () => {
    try {
      await checkPool();
      console.log("object");
      const _isFill = isFilled();
      // console.log(WETHToken.current, 'objeWETHToken.currentct');

      if (!WETHToken.current) return setIsStartBot(false);
      if (_isFill != "filled") return;
      dataInit(); // 数据初始化
      console.log(1);
      // if (_mainConfig.mode === 3 && !isStartGpDx) return setIsStartBot(false)

      // if (_mainConfig.startTime > 0 && _botConfig.isStartTime) { // 机器人是否定时执行
      //   if (downTimeRef.current) clearInterval(downTimeRef.current)
      //   downTimeRef.current = setInterval(() => {
      //     const res: any = downTimeHandler(_mainConfig.startTime)
      //     const str = `${res[0]}:${res[1]}:${res[2]}:${res[3]}`
      //     setDownTime(str)
      //     if (Number(res[4]) <= 0) {
      //       if (downTimeRef.current) clearInterval(downTimeRef.current)
      //       startExecuteBot(0)
      //     }
      //   }, 1000)
      // } else {
      startExecuteBot(0);
      console.log(2);
      // }
    } catch (error) {
      // Notification.Warning(Lang.q16)
      console.log(error);
      setIsStartBot(false);
    }
  };
  // 是否满足前提条件
  const isMeetRequirements = () => {
    let isReq = true;
    let log = "";
    if (!provider) log = "not provider";
    // if (!price) log = Lang.q17
    if (_privatekeyArray.length === 0) log = "not wallet";
    if (log) {
      logHandler(log, ERROR);
      isReq = false;
      setIsStartBot(false);
    }
    return isReq;
  };
  // 执行模式
  const getModeType = () => {
    let buyPro = 0;
    let isFulfill = false;
    let log = "";
    // 拉盘
    if (_mainConfig.mode === 0) {
      buyPro = 100;
      // console.log(_botConfig.price, price, _batchConfig.isBatch, '_batchConfig.isBatch');
      if (
        _botConfig.price &&
        Number(_botConfig.price) <= Number(_pool.price) &&
        !_batchConfig.isBatch &&
        _isAdvanced
      )
        log = Lang.q18;
    }
    // 砸盘
    if (_mainConfig.mode === 1) {
      buyPro = -1;
      if (
        _botConfig.price &&
        Number(_botConfig.price) >= Number(_pool.price) &&
        !_batchConfig.isBatch &&
        _isAdvanced
      )
        log = Lang.q19;
    }
    // 交易量
    if (_mainConfig.mode === 2) {
      buyPro = Number(_botConfig.buyPro);
      if (
        _botConfig.number &&
        Number(_botConfig.number) <= index - walletNotGasError
      )
        log = Lang.q20;
    }
    // 高抛低吸
    if (_mainConfig.mode === 3) {
      // console.log(_botConfig, _pool.price, '_botConfig');
      // 高于最高价 卖单
      if (
        _botConfig.maxPrice &&
        Number(_botConfig.maxPrice) <= Number(_pool.price)
      ) {
        buyPro = -1;
      } else if (
        _botConfig.minPrice &&
        Number(_botConfig.minPrice) >= Number(_pool.price)
      ) {
        buyPro = 100;
      } else {
        log = GPDX;
        setIsStartGpDx(false);
      }
    }
    if (log) {
      logHandler(log, Blue);
      if (log !== GPDX) setIsStartBot(false);
      isFulfill = true;
    }
    return { buyPro, isFulfill };
  };

  // 执行成功
  const timerRef = useRef(null);
  useEffect(() => {
    let timeout: any = null;

    const run = async () => {
      if (index === 0) return;

      // === 1. 优先判断停止信号 ===
      if (stopBot) {
        stopBotHandler();
        return;
      }

      // === 2. 查价逻辑 ===
      try {
        const res = await getPrice(
          provider,
          _token,
          _spenToken,
          _router,
          _chainId,
          Number(_feeV3),
          _v3Factory,
          exchange,
          dispatch,
        );

        if (
          _isAdvanced &&
          _mainConfig.mode === 0 &&
          Number(_botConfig.price) <= Number(res.price) &&
          _botConfig.price
        ) {
          setIndex(0);
          setIsStartBot(false);
          return logHandler("拉盘完成");
        }
        if (
          _isAdvanced &&
          _mainConfig.mode === 1 &&
          Number(_botConfig.price) >= Number(res.price) &&
          _botConfig.price
        ) {
          setIndex(0);
          setIsStartBot(false);
          return logHandler("砸盘完成");
        }
      } catch (err) {
        console.log(err, 'err')
      }



      // === 3. price 未满足 → 随机等待后继续执行 ===
      const time = getRandomNumber(
        Number(_botConfig.minTime),
        Number(_botConfig.maxTime),
      );
      // console.log(_botConfig, 'time');
      logHandler(`${Lang.wait}${time}${Lang.Second}`, Blue);

      timeout = setTimeout(() => {
        startExecuteBot(index);
      }, time * 1000);
    };

    run();

    return () => {
      clearTimeout(timeout);
    };
  }, [index]);

  const walletLocksRef = useRef<Record<string, Promise<void>>>({});

  function queueWalletTask(walletId: string, taskFn: () => Promise<void>) {
    // 链式调用，保证同一个钱包任务串行
    walletLocksRef.current[walletId] = (
      walletLocksRef.current[walletId] || Promise.resolve()
    )
      .then(() => taskFn())
      .catch((err) => {
        console.error(walletId, "任务执行错误:", err);
      });

    return walletLocksRef.current[walletId];
  }
  // 执行机器人
  const currentChain = chains.find(c => c.id === _chainId);

  const startExecuteBot = async (currentIndex: number) => {
    let kkk = _privatekeyArray;
    let walletIndex = 0;
    // 顺序使用钱包
    if (_mainConfig.useWalletWay === 1 && _isAdvanced) {
      walletIndex = getRandomNumber(0, kkk.length - 1);
    } else {
      walletIndex = currentIndex % kkk.length;
    }
    const walletId = walletIndex.toString();
    return queueWalletTask(walletId, async () => {
      const isReq = isMeetRequirements();
      if (!isReq) return;
      // === 交易配置前置校验 ===
      // 交易所/代币地址缺失时不要发单：to0xString('') 会变成 '0x'，
      // 交易会抛 viem 的 Address "0x" is invalid.，从日志根本看不出是哪个地址空了。
      const missConfig: string[] = [];
      const need = (name: string, value?: string) => {
        if (!isAddress(value ?? "")) missConfig.push(name);
      };
      need("代币地址", _token?.address);
      need("支付代币地址", _spenToken?.address);
      if (exchange === "four" || exchange === "flap") {
        need("交易所合约", _router?.address);
        need("Permit2", _permit2);
      } else {
        need("UniversalRouter", _universalRouter);
        need("Permit2", _permit2);
      }
      if (exchange === "V3" || exchange === "V4") {
        need("V3Factory", _v3Factory);
        need("Quoter", _quoter);
      }
      if (exchange === "flap") need("Quoter", _quoter);
      if (missConfig.length > 0) {
        logHandler(
          `交易配置缺失（${missConfig.join("、")}），已停止机器人。请重新选择交易所/代币后重试`,
          ERROR,
        );
        setIndex(0);
        setIsStartBot(false);
        return;
      }
      const randomNumber = getRandomNumber(0, 99);
      const { buyPro, isFulfill } = getModeType();
      if (isFulfill) return;
      let isBuy = true;
      isBuy = buyPro >= randomNumber ? true : false;
      const BASENUMBER = 10000000000;

      const { walletClient: wallet, publicClient } = createViemWallet(kkk[walletIndex], currentChain, _rpc)

      let value = 0n;
      let senderSpendTokenAmount = 0n
      let { buyArg, buyPaths, sellArg, sellPaths, isSpenMianToken } =
        getFuncName(wallet, WETHToken.current);
      try {
        setIndex(currentIndex + 1);

        if (isBuy) {
          /****************************************
           * 🔥 买单 模式
           ****************************************/
          logHandler(
            `${Lang.No}${currentIndex + 1}${Lang.q26}`,
            Blue,
            wallet.account.address,
            2,
          );
          // 完全使用 BigNumber 计算
          const minBuy = new BigNumber(_botConfig.minBuy).times(BASENUMBER);
          const maxBuy = new BigNumber(_botConfig.maxBuy).times(BASENUMBER);
          const buyAmount = getRandomNumber(minBuy.toNumber(), maxBuy.toNumber());

          // 使用 BigNumber 进行精确计算
          const buyAmountBN = new BigNumber(buyAmount);
          const divisorBN = new BigNumber(BASENUMBER);
          const resultBN = buyAmountBN.div(divisorBN);

          // 乘以 10^decimals 得到整数表示
          const decimals = _spenToken.decimals || 18;
          const multiplier = new BigNumber(10).pow(decimals);
          value = resultBN.times(multiplier).toBigInt();


          // 使用代币计算
          if (_mainConfig.isBuyAmount === 1) {
            logHandler(
              `${Lang.q27}:${formatUnits(value, _token.decimals)}-${_token?.symbol}`,
            );
            value = await trageLimitNeedETH(

              value,
              buyPaths,
              isBuy,
              poolKeyArray.current,
              publicClient
            );
          }
          let balance
          if (isMainAddress(_spenToken?.address)) {
            balance = await provider.getBalance({ address: wallet.account.address })
          } else {
            balance = await publicClient.readContract({
              address: to0xString(_spenToken?.address),
              abi: ERC20ABI,
              functionName: 'balanceOf',
              args: [
                wallet.account.address,
              ],
              authorizationList: undefined
            }) as bigint;
          }

          console.log('buyAmount > balance::: ', _mainConfig.isBuyAmount, value, balance, value > balance, wallet.account.address);
          if (_mainConfig.isBuyAmount === 0) {
            if (value > balance) return logHandler(
              `买入金额${formatUnits(value, _spenToken.decimals)}超出钱包${formatUnits(balance, _spenToken.decimals)}可用余额，跳过该钱包`, ERROR
            );
          }
          logHandler(
            `${Lang.q28}:${formatUnits(value, _spenToken.decimals)} ${_spenToken?.symbol}`,
          );

          senderSpendTokenAmount = value;

          // 没用使用平台币交易
          if (!isSpenMianToken) {
            buyArg = [value, ...buyArg];
            value = 0n;
          }

          let minInAmount = 0n

          let spendAmount = isSpenMianToken ? value : buyArg[0];
          console.log('isSpenMianToken::: ', isSpenMianToken);
          if (_isSlippage) {
            const res = await calculateSlippageAmount(
              buyPaths,
              publicClient,
              spendAmount,
              isBuy,
              poolKeyArray.current,
            );

            minInAmount = res;
            console.log('res::: ', res.toString());

            if (isSpenMianToken) {
              buyArg[0] = res;
            } else {
              buyArg[1] = res;
            }
          }
          // console.log(111111111111);
          const res = await executeSwapWithFee({
            wallet,
            path: buyPaths,
            value,
            amountIn: senderSpendTokenAmount,
            isSpenMianToken,
            isBuy,
            amountOutMin: minInAmount,
            spendAmount,
            poolKeyArray: poolKeyArray.current,
            publicClient,
            needsApproval: !spenTokenIsA[walletId],
          });
          logHandler(`${addressHand(wallet.account.address)}交易已打包上链`, Green, res, 1)

          waitForTransactionReceipt(wagmiConfig, {
            hash: res,
            timeout: 60000,    // 超时时间60秒
          }).then((result) => {
            const gasFee = getOnGasFee(result)

            logHandler(`${Lang.q29}:${gasFee}`)

            if (result.status === 'success') {
              logHandler(
                `${Lang.No}${currentIndex + 1}次${Lang.q30}:`,
                Green,
                res,
                1,
              )
            } else {
              logHandler(
                `${Lang.No}${currentIndex + 1}次${Lang.q31}:`,
                ERROR,
                res,
                1,
              )
            }
          }).catch((err) => {
            logHandler(
              `${Lang.No}${currentIndex + 1}次等待链上交易回执超时`,
              ERROR,
              res,
              1,
            )
          });
        } else {
          /****************************************
           * 🔥 卖单 模式
           ****************************************/
          logHandler(
            `${Lang.No}${currentIndex + 1}${Lang.q32}`,
            Blue,
            wallet.account.address,
            2,
          );
          // 卖出金额 或者数量
          const minBuy = Number(_botConfig.minSell) * BASENUMBER;
          const maxBuy = Number(_botConfig.maxSell) * BASENUMBER;
          let sellAmount_ = getRandomNumber(minBuy, maxBuy);
          const balance = await publicClient.readContract({
            address: to0xString(_token?.address),
            abi: ERC20ABI,
            functionName: 'balanceOf',
            args: [
              wallet.account.address,
            ],
            authorizationList: undefined
          }) as bigint;
          console.log('balance::: ', balance);


          if (Number(balance) == 0) {
            logHandler(`代币余额为0，跳过该钱包`, ERROR);
            return;
          }
          let sellAmount = 0n;
          // 选择金额
          if (_mainConfig.isSellAmount === 0) {

            const spenAmount = parseUnits(
              sellAmount_.toString(),
              _spenToken.decimals,
            ) / BigInt(BASENUMBER);
            console.log('spenAmount::: ', spenAmount.toString());

            const res: bigint = await trageLimitNeedETH(
              spenAmount,
              sellPaths,
              isBuy,
              poolKeyArray.current,
              publicClient
            );
            sellAmount = res;

            logHandler(
              `${Lang.q27}:${formatUnits(spenAmount, _spenToken.decimals)}-${_spenToken?.symbol}`,
            );
            logHandler(
              `${Lang.q33}:${formatUnits(sellAmount, _token.decimals)}-${_token?.symbol}`,
            );

            if (sellAmount > balance && balance > 0n) {
              const _amount = formatUnits(
                balance,
                _token.decimals,
              );
              logHandler(
                `${Lang.wallet}${walletIndex + 1}-${Lang.TokenTotal}:${_amount}-${_token?.symbol}--${Lang.q34}`,
              );
              sellAmount = balance;
            }
          }

          // 选择数量
          if (_mainConfig.isSellAmount === 1) {
            const sellAmountBigInt = parseUnits(
              sellAmount_.toString(),
              _token.decimals
            ) / BigInt(BASENUMBER);

            // 打印日志
            logHandler(
              `${Lang.q33}:${formatUnits(sellAmountBigInt, _token.decimals)}-${_token?.symbol}`,
            );

            // 检查余额是否充足
            if (sellAmountBigInt >= balance && balance > 0n) {
              const _amount = formatUnits(balance, _token.decimals);
              logHandler(
                `${Lang.wallet}${walletIndex + 1}-${Lang.TokenTotal}:${_amount}-${_token?.symbol}--${Lang.q34}`,
              );
              sellAmount = balance
            } else {
              sellAmount = sellAmountBigInt
            }

          }
          // 选择百分比
          if (_mainConfig.isSellAmount === 2) {
            const _amount = (sellAmount_ / BASENUMBER).toFixed(0);
            const _div = new BigNumber(_amount);
            const balanceBN = new BigNumber(balance.toString());

            // 计算卖出数量 = 余额 * 百分比 / 100
            const sellAmountBN = balanceBN.multipliedBy(_div).dividedBy(100);
            sellAmount = (sellAmountBN.integerValue(BigNumber.ROUND_DOWN)).toBigInt(); // 向下取整

            logHandler(
              `${Lang.q35}${_div.toString()}, ${Lang.q36}:${formatUnits(sellAmount, _token.decimals)}-${_token?.symbol}`,
            );
          }
          if (Number(sellAmount) == 0) {
            logHandler(`卖出数量为0，执行下一钱包`, Green);
            return;
          }
          console.log('sellAmount::: ', sellAmount);

          let minInAmount = 0n;
          console.log('_isSlippage::: ', _isSlippage);

          if (_isSlippage) {
            console.log('sellAmount::: ', sellAmount.toString());

            const res = await calculateSlippageAmount(
              sellPaths,
              publicClient,
              sellAmount,
              isBuy,
              poolKeyArray.current,
            );
            console.log('res::: ', res.toString());

            minInAmount = res;
            sellArg[0] = res;
          }
          const res = await executeSwapWithFee({
            wallet,
            publicClient,
            path: sellPaths,
            value,
            amountIn: sellAmount,
            isSpenMianToken,
            isBuy,
            amountOutMin: minInAmount,
            sellAmount: sellAmount,
            poolKeyArray: poolKeyArray.current,
            needsApproval: !tokenIsA[walletId],
          });
          logHandler(`${addressHand(wallet.account.address)}交易已打包上链`, Green, res, 1)

          provider.waitForTransactionReceipt({
            hash: res,
            timeout: 60000,    // 超时时间60秒
          }).then((result) => {
            const gasFee = getOnGasFee(result)

            logHandler(`${Lang.q37}:${gasFee}`)

            if (result.status === 'success') {
              logHandler(
                `${Lang.No}${currentIndex + 1}次${Lang.q38}:`,
                Green,
                res,
                1,
              )
            } else {
              logHandler(
                `${Lang.No}${currentIndex + 1}次${Lang.q39}:`,
                ERROR,
                res,
                1,
              )
            }
          }).catch((err) => {
            console.log('err::: ', err);
            logHandler(
              `${Lang.No}${currentIndex + 1}次等待链上交易回执超时`,
              ERROR,
              res,
              1,
            )
          });
        }
      } catch (error) {
        logHandler(errorHandler(error), ERROR);
        console.log(error, "error");
      }
    });
  };

  // 高抛低吸
  const [isStartGpDx, setIsStartGpDx] = useState(false); // 执行高抛低吸

  useEffect(() => {
    if (_mainConfig.mode === 3 && !isStartGpDx && isStartBot) {
      // 高抛
      if (
        _botConfig.maxPrice &&
        Number(_botConfig.maxPrice) <= Number(_pool.price)
      ) {
        logHandler("开始高抛");
        setIsStartGpDx(true);
      } else if (
        _botConfig.minPrice &&
        Number(_botConfig.minPrice) >= Number(_pool.price)
      ) {
        logHandler("开始低吸");
        setIsStartGpDx(true);
      } else {
        let str = "";
        if (_botConfig.minPrice) str = "低吸监听中";
        if (_botConfig.maxPrice) str = "高抛监听中";
        if (_botConfig.minPrice && _botConfig.maxPrice) str = "高抛低吸监听中";
        logHandler(str);
      }
    }
  }, [_pool.price, isStartGpDx, isStartBot]);

  // log 滚动到最下方
  useEffect(() => {
    scrollBottom();
  }, [logoArr]);
  const scrollBottom = () => {
    if (logoArr.length > 60) {
      setLogoArr(logoArr.slice(40));
    }
    const div = document.getElementById("scrolldIV");
    div.scrollTop = div.scrollHeight;
  };
  // 暂停
  const stopBotHandler = () => {
    setIsStartBot(false);
    setIsStartGpDx(false);
    setStopBot(true);
    setIndex(0);
    setDownTime(DEFAULTTIME);
    setWalletNotGasError(0);
    if (timerRef.current) clearInterval(timerRef.current);
    if (downTimeRef.current) clearInterval(downTimeRef.current);
  };
  // 清除
  const clearLog = () => {
    setLogoArr([]);
  };

  const [batchServerError, setBatchServerError] = useState(false);
  useEffect(() => {
    if (provider && batchServerError && _rpc === provider.connection.url) {
      // console.log(provider.connection.url, '批量.connection.url')
      setBatchServerError(false);
      logHandler("批量节点更新成功");
    }
  }, [provider, batchServerError, _rpc]);

  const _v3Factory = useSelector(v3Factory);
  const [load, isLoad] = useState(false);

  async function checkPool() {
    if (!_token?.address || !_spenToken?.address)
      return Notification.Error("请输入代币或等待代币识别完成");
    WETHToken.current = "";
    isLoad(true);
    try {
      const res = await getPrice(
        provider,
        _token,
        _spenToken,
        _router,
        _chainId,
        Number(_feeV3),
        _v3Factory,
        exchange,
        dispatch,
      );
      console.log(res, "res");
      WETHToken.current = res.WETHToken;
      dispatch(poolChange(res));
      poolKeyArray.current = res.arr;
    } catch (err) {
      console.log('err::: ', err);
      Notification.Error("查池子失败" + String(err));
    }



    isLoad(false);
  }
  const [isSell, setIsSell] = useState(0);

  async function suoHa(
    isBuy: boolean,
    val?: { value: string; value1: string; extraValue: string },
  ) {
    console.log("val::: ", val);
    setLogoArr([]);
    setIsSell(isBuy ? 2 : 1);
    const BASENUMBER = 1000000;

    let buyAmount: number;
    if (isBuy) {
      const minBuy = Number(val.value) * BASENUMBER;
      const maxBuy = Number(val.value1) * BASENUMBER;
      const Amount_ = getRandomNumber(minBuy, maxBuy);
      buyAmount = Amount_ / BASENUMBER;
    }

    if (walletAddrArr?.length) {
      await checkPool();
      for (let i = 0; i < walletAddrArr.length; i++) {
        executeSwapSingle(i, isBuy, buyAmount ? buyAmount.toString() : walletConfig.TOKENbArr[i], isBuy ? val.extraValue : "", WETHToken.current, poolKeyArray.current, logHandler); // 无额外判断，直接执行
      }
    }
    await delay(8000);
    Notification.Success("success");
    setIsSell(0);
    getWalletInfo();
  }


  const [modalInfo, setModalInfo] = useState<ModalInfo | null>(null);
  const openModal = (config: ModalInfo) => {
    setModalInfo({
      title: config.title,
      type: config.type,
      handleOk: config.handleOk,
      msg: config.msg,
      confirm: config.confirm,
      account: config.account,
    });
  };
  const [isBuyAllAprove, setIsBuyAllAprove] = useState(false);

  const closeModal = () => {
    setModalInfo(null);
  };
  const _permit2 = useSelector(permit2);

  const approveAllToken = async () => {
    try {
      setIsBuyAllAprove(true);

      for (let index = 0; index < _privatekeyArray.length; index++) {
        const { walletClient: wallet, publicClient } = createViemWallet(_privatekeyArray[index], currentChain, _rpc)

        // 根据操作类型选择路径
        await tokenApproveHandler(
          wallet,
          _permit2,
          _token?.address,
          publicClient
        );
      }
      setIsBuyAllAprove(false);
      logHandler(`授权完成`);
    } catch (error) {
      setIsBuyAllAprove(false);
      console.log(error, "error");
      // let errorResult = errorHandler(error)
      logHandler(`${error.toString()}`, "red");
    }
    getWalletInfo()
  };

  return (
    <StartBot>
      {modalInfo && (
        <ModelInput
          callBack={closeModal}
          handleOks={modalInfo.handleOk}
          title={modalInfo.title}
          type={modalInfo.type}
          msg={modalInfo.msg}
          confirm={modalInfo.confirm}
        />
      )}
      <WalletBtn>
        <Button
          onClick={startBtnClick}
          isLoading={isStartBot}
          endIcon={isStartBot && <AutoRenewIcon spin color="currentColor" />}
        >
          {Lang.startBuy}
        </Button>
        <Button onClick={stopBotHandler}>{Lang.a6}</Button>
        <Button
          onClick={approveAllToken}
          isLoading={isBuyAllAprove}
          endIcon={
            isBuyAllAprove && <AutoRenewIcon spin color="currentColor" />
          }
        >
          提前授权
        </Button>

        <Button
          isLoading={isSell === 2}
          onClick={() =>
            openModal({
              title: "一键买入参数设置",
              handleOk: (val) => {
                if (
                  typeof val === "object" &&
                  (Number(val.extraValue) < 0 || Number(val.extraValue) > 100)
                )
                  return Notification.Error("滑点设置应在0-100");
                suoHa(true, val as any);
              },
              type: 1,
              confirm: "买入",
            })
          }
        >
          一键买入{isSell === 2 && <LoadingOutlined />}
        </Button>

        <Button isLoading={isSell === 1} onClick={() => suoHa(false)}>
          一键清仓{isSell === 1 && <LoadingOutlined />}
        </Button>
      </WalletBtn>

      <div className="fee-box">
        {_vip ? (
          <>
            <div className="fee-info">
              <div className="fee-lines">
                <span>
                  邀请好友开通会员，邀请者额外获<span style={{ color: "red" }}> 20% </span>会员时长奖励。
                </span>
              </div>

            </div>
            <button
              className="fee-btn"
              onClick={() => copyHandler(`https://www.gtokentool.com/bot?invite=${account}`)}
            >
              复制邀请链接
            </button>
          </>
        ) : <>
          <div className="fee-info">
            <div className="fee-lines">
              <span className="fee-label">非会员费用：</span>
              <span className="fee-amount">
                {NOVIP_AMOUNT[_chainId]}
                {chains.find((c) => c.id === _chainId).nativeCurrency?.symbol || 'ETH'} /
                笔交易
              </span>
            </div>

            <span className="fee-tip">(升级为会员可免除此费用)</span>
          </div>
          <button
            className="fee-btn"
            onClick={() => window.open("https://www.gtokentool.com/bot")}
          >
            解锁{isApp() && "网页版"}会员权益
          </button>
        </>}

      </div>

      <LogoSwapper id="scrolldIV">
        <div className="pool-row">
          <FormLabel>
            {Lang.poolAddress}:{addressHand(_pool.pairAddress)}
            <CopyOutlined onClick={() => copyHandler(_pool.pairAddress)} />
          </FormLabel>

          <button className="icon-btn" onClick={checkPool}>
            {load ? <LoadingOutlined /> : "🔍"}
          </button>
        </div>

        <FormLabel>
          {Lang.currentprice}:{_pool.price}{" "}
          {MainTokenConfig[_chainId][0].address.toLowerCase() ===
            _spenToken?.address?.toLowerCase()
            ? "U"
            : _spenToken?.symbol}
          <CopyOutlined onClick={() => copyHandler(_pool.price)} />
        </FormLabel>
        <div style={{ textAlign: "right", marginRight: 20 }} onClick={clearLog}>
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5591"
            width="20"
            height="20"
          >
            <path
              d="M878.411294 534.287059L806.550588 393.155765a73.065412 73.065412 0 0 0-65.415529-40.116706h-109.628235a1.867294 1.867294 0 0 1-1.92753-1.867294V172.694588a53.007059 53.007059 0 0 0-53.007059-53.007059H491.941647a53.007059 53.007059 0 0 0-53.007059 53.007059V351.171765a1.867294 1.867294 0 0 1-1.807059 1.867294H327.258353c-27.708235 0-52.766118 15.36-65.415529 40.116706L190.102588 534.287059a54.272 54.272 0 0 0 2.108236 53.308235c9.637647 15.781647 26.262588 25.419294 44.574117 25.961412-4.517647 95.051294-36.020706 193.776941-84.931765 263.047529a54.452706 54.452706 0 0 0 44.634353 86.016h566.15153a73.487059 73.487059 0 0 0 70.77647-53.970823c14.576941-53.187765 26.744471-101.556706 27.708236-155.226353a319.247059 319.247059 0 0 0-28.310589-139.866353 54.452706 54.452706 0 0 0 45.598118-79.269647z m-641.325176 23.913412l71.80047-141.131295a20.660706 20.660706 0 0 1 18.432-11.324235h109.628236c30.117647 0 54.512941-24.455529 54.512941-54.573176V172.694588c0-0.060235 0.180706-0.240941 0.301176-0.240941H576.451765c0.120471 0 0.301176 0.180706 0.301176 0.240941V351.171765c0 30.117647 24.455529 54.573176 54.573177 54.573176H740.894118c7.830588 0 14.878118 4.336941 18.432 11.324235l71.80047 141.131295c0.240941 0.301176 0.481882 0.963765-0.060235 1.927529-0.602353 0.903529-1.204706 0.903529-1.626353 0.903529H238.772706c-0.361412 0-1.024 0-1.626353-0.903529-0.542118-0.963765-0.240941-1.626353-0.060235-1.927529z m571.392 194.258823c-0.843294 47.585882-12.167529 92.521412-25.780706 142.21553a20.781176 20.781176 0 0 1-19.998118 15.239529h-119.145412c10.661647-20.961882 17.468235-41.381647 21.744942-57.584941 6.686118-25.118118 10.059294-50.356706 9.999058-73.426824a26.322824 26.322824 0 0 0-52.705882 0.421647c0.060235 40.176941-13.251765 92.400941-40.176941 130.590118H412.431059a324.367059 324.367059 0 0 0 51.561412-126.494118 26.383059 26.383059 0 0 0-51.922824-8.613647c-2.650353 15.661176-7.830588 35.478588-16.685176 56.801883-9.517176 23.190588-26.142118 54.693647-52.344471 78.426353h-146.371765c-0.542118 0-1.204706 0-1.807059-1.024-0.481882-1.024-0.120471-1.505882 0.120471-1.867295 28.009412-39.634824 51.621647-88.967529 68.246588-142.516705a599.341176 599.341176 0 0 0 26.383059-150.889412h484.291765c24.214588 43.670588 35.538824 89.268706 34.575059 138.721882z"
              p-id="5592"
              fill="#1fc7d4"
            ></path>
          </svg>
        </div>

        {_botConfig.isStartTime && (
          <Text bold fontSize="30px" mt="6px">
            {Lang.downTime}: {downTime}
          </Text>
        )}
        <div style={{ maxHeight: "100%", overflowY: "auto" }}>
          {logoArr
            .slice()
            .reverse()
            .map((item, index) => (
              <Flex key={index} mt="6PX">
                <Text color={item.color}>{item.time}:</Text>
                <Text
                  color={item.color}
                  onClick={() => {
                    if (item.num === 1) {
                      window.open(
                        `${chains.find((item) => item.id === _chainId).blockExplorers.default.url}/tx/${item.hash}`,
                      );
                    }
                  }}
                  style={{ cursor: item.num === 1 ? "pointer" : "default" }} // 鼠标样式更直观
                >
                  {item.content}
                  {addressHand(item.hash)}
                  {item.num === 2 && (
                    <CopyOutlined onClick={() => copy(item.hash)} />
                  )}
                </Text>
              </Flex>
            ))}
        </div>
      </LogoSwapper>
    </StartBot>
  );
}

export default memo(App);
export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
